import { render, staticRenderFns } from "./TodasComprasDiretasTabela.vue?vue&type=template&id=b5ec91b8&scoped=true"
import script from "./TodasComprasDiretasTabela.vue?vue&type=script&lang=js"
export * from "./TodasComprasDiretasTabela.vue?vue&type=script&lang=js"
import style0 from "./TodasComprasDiretasTabela.vue?vue&type=style&index=0&id=b5ec91b8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ec91b8",
  null
  
)

export default component.exports